export const RESET_LOADING = 'RESET_LOADING';
export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';

export const resetLoading = () => ({ type: RESET_LOADING });

export const addLoadingCount = incomingApi => ({ type: LOADING_START, incomingApi });

export const reduceLoadingCount = incomingApi => ({ type: LOADING_STOP, incomingApi });


// WEBPACK FOOTER //
// ./src/shells/LoadingComponent/actions.js